import { watch } from 'vue'

const hiraToKata = (str) => {
  return str.replace(/[\u3041-\u3096]/g, (match) => {
    const chr = match.charCodeAt(0) + 0x60
    return String.fromCharCode(chr)
  })
}

const isPointPartiallyMatched = (point, keyword) => {
  const pointJaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.point_ja))
  const pointEnMatched = new RegExp(keyword, 'i').test(point.point_en)
  return pointJaMatched || pointEnMatched
}

const isPointFullyMatched = (point, keyword) => {
  const pointJaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point.point_ja))
  const pointEnFullMatched = new RegExp(`^${keyword}$`, 'i').test(point.point_en)
  return pointJaFullMatched || pointEnFullMatched
}

const isCountryPartiallyMatched = (point, keyword) => {
  const countryJaMatched = new RegExp(keyword, 'i').test(hiraToKata(point.country_ja))
  const countryEnMatched = new RegExp(keyword, 'i').test(point.country_en)
  return countryJaMatched || countryEnMatched
}

const isIataCodePartiallyMatched = (point, keyword) => {
  return new RegExp(keyword, 'i').test(point.iata_code ?? '')
}

const isIataCodeFullyMatched = (point, keyword) => {
  return new RegExp(`^${keyword}$`, 'i').test(point.iata_code ?? '')
}

export const useWorldPointSearch = ({ searchPointList, areaId }) => {
  const keyword = ref('')
  const result = ref([])
  const allPointList = Object.entries(searchPointList)
    .map(([pointId, point]) => ({ pointId, ...point }))
    .filter((point) => {
      if (!areaId) return true
      return point.pointId.startsWith(`/${areaId}/`)
    })
  const isNotFound = computed(() => {
    return keyword.value !== '' && result.value.length === 0
  })

  watch(keyword, () => {
    search()
  })

  const search = () => {
    if (keyword.value === '') {
      result.value = []
      return
    }

    // eslint-disable-next-line no-irregular-whitespace
    const normalizedKeyworld = hiraToKata(keyword.value).replace(/　/g, ' ')

    const pointTypeScore = {
      city: 3,
      landmark: 2,
      airport: 1
    }

    result.value = allPointList
      .map((point) => {
        let score = 0
        if (isPointPartiallyMatched(point, normalizedKeyworld)) score += 2
        if (isPointFullyMatched(point, normalizedKeyworld)) score += 1
        if (isCountryPartiallyMatched(point, normalizedKeyworld)) score += 1
        if (isIataCodePartiallyMatched(point, normalizedKeyworld)) score += 1
        if (isIataCodeFullyMatched(point, normalizedKeyworld)) score += 2

        if (score > 0) {
          score += pointTypeScore[point.point_type]
        }
        return { ...point, score }
      })
      .filter((point) => point.score > 0)
      .sort((a, b) => b.score - a.score)
  }

  return {
    keyword,
    result,
    isNotFound
  }
}
